'use client';

import { Tick01Icon, Copy01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Clipboard } from '../../components/clipboard';
import { IconButton } from '../../components/icon-button';
import { Tooltip } from '../../components/tooltip';
import { toasterApi } from '../toast/ToastProvider';

type CopyIdButtonProps = {
  id: string;
  entityName: string;
};

export const CopyIdButton = ({ id, entityName }: CopyIdButtonProps) => {
  const t = useTranslations('designSystem.common.copyId');
  const label = t('copyLabel', { entityName });

  return (
    <Clipboard.Root
      value={id}
      onStatusChange={({ copied }) => {
        if (copied) {
          toasterApi.success({
            title: t('copiedTitle', { entityName }),
            description: id,
          });
        }
      }}
    >
      <Tooltip title={label}>
        <Clipboard.Trigger asChild>
          <IconButton variant="ghost" size="xs" aria-label={label}>
            <Clipboard.Indicator copied={<Tick01Icon size={14} />}>
              <Copy01Icon size={14} />
            </Clipboard.Indicator>
          </IconButton>
        </Clipboard.Trigger>
      </Tooltip>
    </Clipboard.Root>
  );
};
